<template>
  <notification-sent-modal
    v-if="isSent"
  />
  <v-btn
    v-else
    color="success"
    class="ml-2"
    type="submit"
    :loading="loading"
  >
    Salvar
  </v-btn>
</template>

<script>
import NotificationSentModal from 'Modules/contacard/communication/notifications/components/modals/NotificationSentModal.vue';

export default {
  name: 'NotificationSaveButton',
  components: { NotificationSentModal },
  computed: {
    getStatus() {
      return this.notification.status;
    },
    isSent() {
      return this.getStatus === 'Sent' || this.getStatus === 'Pending';
    },
    loading() {
      return this.notification.loading;
    },
  },
  inject: {
    notification: {
      default() {
        return {
          status: '',
          loading: '',
        };
      },
    },
  },
};
</script>
